/***********
 General
 ***********/

const headerElement = document.querySelector('#header');
const miniSearchContent = document.querySelector('#miniSearchContentResults');

document.addEventListener('DOMContentLoaded', function () {
    // drop swiper
    var desktopMenuSlider = headerElement && headerElement.querySelector('.swiper');
    if (desktopMenuSlider && !desktopMenuSlider.swiper && desktopMenuSlider.querySelectorAll('.swiper-slide').length > 1) new Swiper(desktopMenuSlider, {
        slidesPerView: 1,
        pagination: {
            el: headerElement.querySelector('.swiper-pagination'),
        },
        autoplay: {
            delay: 4000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: true
    })
    // drop mobile swiper
    var mobileMenuSlider = document.querySelector('#slider .swiper');
    if (mobileMenuSlider && !mobileMenuSlider.swiper && mobileMenuSlider.querySelectorAll('.swiper-slide').length > 1) new Swiper(mobileMenuSlider, {
        slidesPerView: 1,
        pagination: {
            el: document.querySelector('#slider .swiper-pagination'),
        },
        autoplay: {
            delay: 4000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: true
    })
})


/******************
 Search Bar
 ******************/

// open search element
headerElement.querySelector('#headerSearch').addEventListener('click', function () {
    headerElement.querySelector('#headerSearchDisplay').classList.add('active');
    // clear current search input and focus cursor
    headerElement.querySelector('.headerSearchInput').value = "";
    headerElement.querySelector('.headerSearchInput').focus();
    document.querySelector('#miniSearchContentResults').innerHTML = `
    <div id="miniSearchContentResultsEmpty">No Results...</div>
    `;
    document.querySelector('#miniSearchContentSuggestions').classList.add('active');
    miniSearchReading();
})

// exit button
headerElement.querySelector('#headerSearchDisplayFormExit').addEventListener('click', function (e) {
    e.preventDefault();
    this.closest('#headerSearchDisplay').classList.remove('active');
    miniSearchReading(true);
})
// exit with background
document.querySelector('#miniSearchBackdrop').addEventListener('click', function () {
    document.querySelector('#headerSearchDisplay').classList.remove('active');
    miniSearchReading(true);
})

// listener on the search input
const searchInput = headerElement.querySelector('.headerSearchInput');
let searchTimer;
let searchRequest;
let searchVersion = 0;
let searchIsOpen = false;

function cancelSearch() {
    clearTimeout(searchTimer);
    searchVersion++;
    if (searchRequest) searchRequest.abort();
    searchRequest = null;
}

function miniSearchReading(reset = false) {
    cancelSearch();
    searchIsOpen = !reset;
    document.querySelector('#miniSearch')?.classList.toggle('active', !reset);
    document.body.classList.toggle('noScroll', !reset);
    document.querySelector('#miniSearchContentTopLink span').textContent = '';
}

function escapeSearchHTML(value) {
    return String(value ?? '').replace(/[&<>"']/g, character => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[character]);
}

async function activeSearch() {
    cancelSearch();
    const query = searchInput.value.trim();
    const version = searchVersion;
    document.querySelector('#miniSearchContentTopLink span').textContent = query;
    if (!query || !searchIsOpen) {
        miniSearchContent.innerHTML = '<div id="miniSearchContentResultsEmpty">No Results...</div>';
        document.querySelector('#miniSearchContentSuggestions').classList.add('active');
        return;
    }
    searchRequest = new AbortController();
    try {
        const response = await fetch(`${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&country=${encodeURIComponent(window.Shopify.country)}`, { signal: searchRequest.signal });
        if (!response.ok) throw new Error('Search request failed');
        const data = await response.json();
        if (version !== searchVersion || !searchIsOpen) return;
        const products = data.resources.results.products;
        miniSearchContent.innerHTML = products.length ? products.map(result => {
            const isB2B = result.tags && result.tags.includes('B2B ONLY');
            return `<a class="miniSearchItem" href="${escapeSearchHTML(result.url)}">
                <img class="miniSearchItemImage" src="${escapeSearchHTML(result.image)}" alt="product image" />
                <div class="miniSearchItemText">
                    <h3 class="miniSearchItemTitle">${escapeSearchHTML(result.title)}</h3>
                    ${!isB2B ? `<p class="miniSearchItemPrice">${formatStoreMoney(Math.round(Number(result.price) * 100))}</p>` : ''}
                </div>
            </a>`;
        }).join('') : '<div id="miniSearchContentResultsEmpty">No Results...</div>';
        document.querySelector('#miniSearchContentSuggestions').classList.remove('active');
    } catch (error) {
        if (error.name !== 'AbortError' && version === searchVersion) console.error(error.message);
    }
}

searchInput.addEventListener('input', function () {
    cancelSearch();
    if (!searchInput.value.trim()) { activeSearch(); return; }
    searchTimer = setTimeout(activeSearch, 180);
});
headerElement.querySelector('#headerSearchDisplayFormIcon').addEventListener('click', function (event) {
    event.preventDefault();
    activeSearch();
});
document.querySelector('#miniSearchContentTopLink').addEventListener('click', function () {
    const query = searchInput.value.trim();
    if (query) window.location.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(query)}&type=product`;
});

/**************
 Mobile Nav
 ***************/

// open nav
function openNav() {
    const headerBottom = document.querySelector('#header').getBoundingClientRect().bottom;
    document.querySelector('#sliderContent').style.height = `calc(100% - ${headerBottom}px)`
    document.querySelector("#slider").classList.add("active");
    document.querySelector("body").classList.add("noScroll");
    document.querySelector('#sliderExit').classList.add('active');
    document.querySelector('#headerMenu').classList.remove('active');
}

// close nav
function closeNav() {
    // for smooth transition, add animation
    document.querySelector("#slider").classList.add("deactivate");
    // remove classes once animation has safely run
    setTimeout(() => {
        document.querySelector("#slider").classList.remove("active");
        document.querySelector("#slider").classList.remove("deactivate");
    }, 500);
    document.querySelector("body").classList.remove("noScroll");
    document.querySelector('#sliderExit').classList.remove('active');
    document.querySelector('#headerMenu').classList.add('active');

    // reset slider menu if submenu is open
    if (document.querySelector('.sliderNavItem.active')) {
        document.querySelector('.sliderNavItem.active').classList.remove('active');
    }
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// open and close sub menu
document.querySelectorAll('.headerNavItem.dropMenu .headerNavItemTitle').forEach(el => {
    el.addEventListener('click', function () {
        el.classList.toggle('active');
    })
});
